import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { ProfileProvider } from "./hooks/useProfile";

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <Routes />
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;
